import {forwardRef, useImperativeHandle, useMemo, useState} from 'react';
import {useSelector} from 'react-redux';
import { find } from 'lodash';
import {agylePref} from '../../../../store/reducers/preferences';
import AgyleDictionaryField from '../../../ui/selector/agyleDictionaryField';
import {
    CONTEXT_OPTIONS,
    SCHEDULER_PREFERENCE_DEFAULT_VIEW_OPTIONS,
} from '../../../../pages/appointments/utils/constants/appointmentSessionConstants';

const DEFAULT_STATE = find(SCHEDULER_PREFERENCE_DEFAULT_VIEW_OPTIONS, { value: CONTEXT_OPTIONS.SWIM_LANES });

const DefaultSchedulerView = forwardRef((props, ref) => {
    const agylePreference = useSelector(agylePref);

    const [defaultView, setDefaultView] = useState(agylePreference?.defaultSchedulerView ? agylePreference?.defaultSchedulerView : DEFAULT_STATE.value);

    // Return default state of a component
    useImperativeHandle(ref, () => ({
        defaultState: () => {
            setDefaultView(DEFAULT_STATE.value);
            return DEFAULT_STATE;
        },
    }));

    const handleChange = (_ev, val) => {
        setDefaultView(val.value);
        props.onChange('defaultSchedulerView', val.value);
    };

    const currValue = useMemo(() => {
        return find(SCHEDULER_PREFERENCE_DEFAULT_VIEW_OPTIONS, { value: defaultView })
    }, [defaultView])

    return (
        <AgyleDictionaryField
            paperBackground
            value={currValue}
            withBackground={false}
            onChange={handleChange}
            getOptionLabel={option => option.description}
            options={SCHEDULER_PREFERENCE_DEFAULT_VIEW_OPTIONS}
            isOptionEqualToValue={(option, value) => option.value === currValue?.value}
        />
    );
})

export default DefaultSchedulerView;